import { TICKET_PRIORITY_ICONS } from "../../../hooks/useTicketPriorities";
import { ReactComponent as AssigneesIcon } from "../assets/assignees.svg";
import { ReactComponent as CalendarIcon } from "../assets/calendar.svg";
import { ReactComponent as CreatedIcon } from "../assets/created.svg";
import { ReactComponent as CustomerIcon } from "../assets/customer.svg";
import { ReactComponent as InProgressIcon } from "../assets/in-progress.svg";
import { ReactComponent as IssuedIcon } from "../assets/issued.svg";
import { ReactComponent as OnCustomerIcon } from "../assets/on-customer.svg";
import { ReactComponent as OnHoldIcon } from "../assets/on-hold.svg";
import { ReactComponent as ResolvedIcon } from "../assets/resolved.svg";
import { TicketHistoryIconVariant } from "../types";

export const getTicketHistoryIcon = (icon: TicketHistoryIconVariant) => {
  switch (icon.kind) {
    case "created":
      return <CreatedIcon />;
    case "customer":
      return <CustomerIcon />;
    case "assignees":
      return <AssigneesIcon />;
    case "due_date":
      return <CalendarIcon />;
    case "priority": {
      const Icon = TICKET_PRIORITY_ICONS[icon.priority];
      return <Icon className="size-5" />;
    }
    case "status":
      switch (icon.status) {
        case "resolved":
          return <ResolvedIcon />;
        case "in_progress":
          return <InProgressIcon />;
        case "on_customer":
          return <OnCustomerIcon />;
        case "on_hold":
          return <OnHoldIcon />;
        case "issued":
          return <IssuedIcon />;
        default:
          return <InProgressIcon />;
      }
    default:
      return <CreatedIcon />;
  }
};
